import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { CalcProvider } from "@/state/CalcContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <CalcProvider>
          <App />
        </CalcProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
